import { Warning } from "@phosphor-icons/react";

/**
 * Legal disclaimer for AI-generated images.
 * Required for liability protection: AI overlays are simulations, not certified plans.
 */
export function AIDisclaimer({ compact = false }) {
  if (compact) {
    return (
      <div className="bg-[#1A1A1A] border-l-4 border-[#FF9500] rounded p-2 text-[10px] text-[#D4D4D4] leading-snug mt-2 flex gap-2"
        data-testid="ai-disclaimer-compact">
        <Warning size={14} weight="fill" className="text-[#FF9500] shrink-0 mt-0.5" />
        <span>
          <b className="text-[#FF9500] uppercase">Avviso IA.</b> Le immagini IA sono <b>simulazioni grafiche</b>.
          ETA Build <b>non sostituisce il Pi.M.U.S.</b> o i calcoli strutturali certificati.
          L&apos;utente è l&apos;unico responsabile della sicurezza in cantiere.
        </span>
      </div>
    );
  }
  return (
    <div className="bg-[#FF9500]/5 border-l-4 border-[#FF9500] rounded-md p-3 flex gap-3 mt-3"
      data-testid="ai-disclaimer">
      <Warning size={20} weight="fill" className="text-[#FF9500] shrink-0 mt-0.5" />
      <p className="text-xs text-[#D4D4D4] leading-snug">
        <b className="text-[#FF9500] uppercase">Avviso IA.</b> Le immagini generate dall&apos;intelligenza artificiale sono{" "}
        <b className="text-white">simulazioni grafiche</b> a scopo illustrativo. ETA Build <b className="text-white">non sostituisce
        il Pi.M.U.S.</b> (Piano di Montaggio, Uso e Smontaggio dei ponteggi) né i calcoli strutturali
        certificati richiesti dalla normativa. L&apos;utente è l&apos;unico responsabile della verifica
        tecnica e della sicurezza in cantiere ai sensi del D.Lgs. 81/2008.
      </p>
    </div>
  );
}
